// Full updated HomeBanner component with edit functionality
import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { homeBannerApi } from "../../app/slices/HomeBanner/homeBannerListSlice";
import { FormHelperText } from "@mui/material";
import CustomTable from "../../components/customTable/CustomTable";
import { createMRTColumnHelper } from "material-react-table";
import { toast, ToastContainer } from "react-toastify";
import { IoMdOpen } from "react-icons/io";
// import { ArrowBack } from "@mui/icons-material";
import Swal from "sweetalert2";
import axiosInstance from "../../utils/axiosInstance";
import { useFileTypeValidator } from "../../utils/fileTypeValidator";

export default function HomeBanner() {
  const dispatch = useDispatch();
  const baseUrl = import.meta.env.VITE_BASE_URL;
  const token = localStorage.getItem("token");
  const roleResponse = useSelector((state) => state.login.login.role);
  const headers = { Authorization: `Bearer ${token}` };

  const initialFormState = {
    _id: null,
    title: "",
    active: 0,
    subtitle: "",
    buttonText: "",
    buttonLink: "",
    titleColor: "#442673",
    subtitleColor: "#442673",
    buttonBgColor: "#4A2A7D",
    buttonTextColor: "#FFFFFF",
    portal: "",
    homebanner_upload: null,
    externalLink: "",
  };

  const [formData, setFormData] = useState(initialFormState);
  const [isEditMode, setIsEditMode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const allowedExtensions = ["png", "jpg"];
  const maxSize = 7 * 1024 * 1024;
  const { validatedFile, error: fileError } = useFileTypeValidator(
    selectedFile,
    allowedExtensions,
    maxSize,
  );

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const resetForm = () => {
    setFormData(initialFormState);
    setIsEditMode(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (fileError) {
      toast.error(fileError);
      return;
    }
    setLoading(true);

    if (!formData?.homebanner_upload && !isEditMode) {
      toast.error("Home banner image is required.");
      setLoading(false);
      return;
    }

    if (!formData?.portal) {
      toast.error("Portal field is required.");
      setLoading(false);
      return;
    }
    //  console.log("Submitting homebanner upload with data:", formData.homebanner_upload);
    const formDataToSend = new FormData();
    formDataToSend.append("title", formData.title);
    formDataToSend.append("subtitle", formData.subtitle);
    formDataToSend.append("buttonText", formData.buttonText);
    formDataToSend.append("buttonLink", formData.buttonLink);
    formDataToSend.append("titleColor", formData.titleColor);
    formDataToSend.append("subtitleColor", formData.subtitleColor);
    formDataToSend.append("buttonBgColor", formData.buttonBgColor);
    formDataToSend.append("buttonTextColor", formData.buttonTextColor);
    formDataToSend.append("portal", formData.portal);
    formDataToSend.append("externalLink", formData.externalLink);
    if (formData?.homebanner_upload) {
      formDataToSend.append("homebanner_upload", formData.homebanner_upload);
    }

    const headers = {
      "Content-Type": "multipart/form-data",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    };
    for (let pair of formDataToSend.entries()) {
      console.log(pair[0] + ": ", pair[1]);
    }
    try {
      const response = isEditMode
        ? await axiosInstance.put(
            `/homebanner_update/${formData._id}`,
            formDataToSend,
            { headers },
          )
        : await axiosInstance.post(`/uploadhomebanner`, formDataToSend, {
            headers,
          });
      // const response = isEditMode
      //   ? await axios.put(
      //     `${baseUrl}/homebanner_update/${formData._id}`,
      //     formDataToSend,
      //     { headers }
      //   )
      //   : await axios.post(`${baseUrl}/uploadhomebanner`, formDataToSend, {
      //     headers,
      //   });

      if (response.data?.error === false) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: response?.data?.message || "Success",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "OK",
        });
      } else {
        Swal.fire({
          icon: "error",
          text: response?.data?.message,
          timer: 3000,
          showConfirmButton: false,
        });
      }

      dispatch(homeBannerApi());
      resetForm();
      setLoading(false);
    } catch (error) {
      console.error("Upload failed:", error);
      const errorMessage =
        error?.response?.data?.message || "something went to wrong !";
      Swal.fire({
        text: errorMessage,
        icon: "error",
        timer: 3000,
        showConfirmButton: false,
      });
      setLoading(false);
    }
  };

  const handleEdit = (rowData) => {
    setFormData({
      ...rowData,
      homebanner_upload: null,
    });
    setIsEditMode(true);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // const handleDelete = async (rowData) => {
  //   try {
  //     const response = await axios.post(
  //       `${baseUrl}/homebanner_delete/${rowData._id}`,
  //       {},
  //       { headers }
  //     );
  //     Swal.fire({
  //       icon: "success",
  //       title: "Deleted",
  //       text: response?.data?.message || "Deleted successfully!",
  //       confirmButtonColor: "#3085d6",
  //       confirmButtonText: "OK",
  //     });
  //     dispatch(homeBannerApi());
  //   } catch (error) {
  //     toast.error("Error deleting home banner: " + error.message);
  //   }
  // };

  const handleDelete = async (rowData) => {
    try {
      const confirmResult = await Swal.fire({
        title: "Are you sure?",
        text: "This action cannot be undone!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, delete it!",
      });

      if (confirmResult.isConfirmed) {
        const response = await axiosInstance.post(
          `/homebanner_delete/${rowData._id}`,
          {},
          // { headers }
        );
        // const response = await axios.post(
        //   `${baseUrl}/homebanner_delete/${rowData._id}`,
        //   {},
        //   { headers }
        // );

        if (response?.data?.error === false) {
          Swal.fire({
            icon: "success",
            title: "Deleted",
            text: response?.data?.message || "Deleted successfully!",
            confirmButtonColor: "#3085d6",
            confirmButtonText: "OK",
            timer: 2000,
          });

          dispatch(homeBannerApi());
        } else {
          Swal.fire({
            icon: "error",
            text: response?.data?.message || "Something went wrong.",
            timer: 2000,
            showConfirmButton: false,
          });
        }
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Deletion Failed",
        text:
          error?.response?.data?.message || error.message || "Unknown error",
        timer: 2000,
      });
    }
  };

  useEffect(() => {
    dispatch(homeBannerApi());
  }, [dispatch]);

  useEffect(() => {
    if (validatedFile) {
      setFormData((prev) => ({
        ...prev,
        homebanner_upload: validatedFile,
      }));
    }
  }, [validatedFile]);

  const sliceResponse = useSelector(
    (state) => state.homeBanner.homeBanner.data,
  );
  const stateLoading = useSelector((state) => state.homeBanner.loading);
  const [open, setOpen] = useState(false);
  const [fullSubtitle, setFullSubtitle] = useState("");

  const columnHelper = createMRTColumnHelper();
  const columns = [
    // columnHelper.accessor("title", { header: "Title" }),
    // columnHelper.accessor("subtitle", { header: "Subtitle" }),
    // columnHelper.accessor("buttonText", { header: "Button Text" }),
    // columnHelper.accessor("buttonLink", { header: "Button Link" }),
    // columnHelper.accessor("portal", { header: "Portal" }),

    columnHelper.accessor("title", {
      header: "Title",
    }),

    columnHelper.accessor("externalLink", {
      header: "External Link",
      Cell: ({ cell }) => {
        const link = cell.getValue();
        return (
          <Tooltip title={link}>
            <a
              href={link}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "blue" }}
            >
              {link ? "Link" : ""}
            </a>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("subtitle", {
      header: "Subtitle",
      Cell: (cell) => {
        const subtitle = cell?.row?.original?.subtitle || "";

        const maxLength = 50;
        const isLong = subtitle.length > maxLength;
        const shortSubtitle = isLong
          ? `${subtitle.slice(0, maxLength)}...`
          : subtitle;

        const openFullSubtitleModal = () => {
          setOpen(true); // use your modal state
          setFullSubtitle(subtitle); // store subtitle in state
        };

        return (
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            {isLong && (
              <Tooltip title="Show Full Subtitle">
                <IconButton onClick={openFullSubtitleModal}>
                  <IoMdOpen fontSize={"1rem"} color="black" />
                </IconButton>
              </Tooltip>
            )}
            <Tooltip title={subtitle} arrow>
              <span>{shortSubtitle}</span>
            </Tooltip>
          </Box>
        );
      },
    }),

    columnHelper.accessor("buttonText", {
      header: "Button Text",
    }),
    columnHelper.accessor("buttonLink", {
      header: "Button Link",
      Cell: ({ cell }) => {
        const link = cell.getValue();
        return (
          <Tooltip title="Open Link" arrow>
            <a
              href={link}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "blue" }}
            >
              {link ? "Link" : ""}
            </a>
          </Tooltip>
        );
      },
    }),

    columnHelper.accessor("imageUrl", {
      header: "Banner Image",
      Cell: ({ cell }) => {
        const fileUrl = cell.getValue();

        return fileUrl ? (
          <Tooltip title="Click to view full image">
            <Box
              component="a"
              href={fileUrl}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                display: "inline-block",
                width: 80,
                height: 50,
                overflow: "hidden",
                borderRadius: 1,
                border: "1px solid #ccc",
                "& img": {
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  transition: "0.3s",
                  "&:hover": {
                    transform: "scale(1.05)",
                  },
                },
              }}
            >
              <img src={fileUrl} alt="Preview" />
            </Box>
          </Tooltip>
        ) : (
          <Typography variant="body2" color="textSecondary">
            No File
          </Typography>
        );
      },
    }),
    columnHelper.accessor("titleColor", {
      header: "Title Color",
      Cell: ({ cell }) => (
        <div
          style={{
            backgroundColor: cell.getValue(),
            padding: "5px",
            color: "#000",
          }}
        >
          {cell.getValue()}
        </div>
      ),
    }),
    columnHelper.accessor("subtitleColor", {
      header: "Subtitle Color",
      Cell: ({ cell }) => (
        <div
          style={{
            backgroundColor: cell.getValue(),
            padding: "5px",
            color: "#000",
          }}
        >
          {cell.getValue()}
        </div>
      ),
    }),
    columnHelper.accessor("buttonBgColor", {
      header: "Button BG",
      Cell: ({ cell }) => (
        <div
          style={{
            backgroundColor: cell.getValue(),
            padding: "5px",
            color: "#000",
          }}
        >
          {cell.getValue()}
        </div>
      ),
    }),
    columnHelper.accessor("buttonTextColor", {
      header: "Button Text Color",
      Cell: ({ cell }) => (
        <div
          style={{
            backgroundColor: cell.getValue(),
            padding: "5px",
            color: "#000",
          }}
        >
          {cell.getValue()}
        </div>
      ),
    }),
    columnHelper.accessor("portal", {
      header: "Portal",
      Cell: ({ cell }) => (
        <div
          style={{
            backgroundColor: cell.getValue(),
            padding: "5px",
            color: "#000",
          }}
        >
          {cell.getValue()}
        </div>
      ),
    }),

    columnHelper.accessor("active", {
      header: "Status",
      Cell: ({ row }) => {
        const isActive = row.original.active;
        const rowId = row.original._id;

        const handleStatusToggle = async () => {
          const updatedStatus = !isActive ? 1 : 0;

          const formDataToSend = new FormData();
          formDataToSend.append("status", updatedStatus);

          try {
            const response = await axiosInstance.post(
              `/homebanner_status_update/${rowId}`,
              formDataToSend,
              // {
              //   headers: {
              //     ...headers,
              //     "Content-Type": "application/json",
              //   },
              // }
            );
            // const response = await axios.post(
            //   `${baseUrl}/homebanner_status_update/${rowId}`,
            //   formDataToSend,
            //   {
            //     headers: {
            //       ...headers,
            //       "Content-Type": "application/json",
            //     },
            //   }
            // );

            Swal.fire({
              icon: "success",
              title: "Success",
              text: response?.data?.message || "Home banner status updated!",
              confirmButtonColor: "#3085d6",
              confirmButtonText: "OK",
            });
            dispatch(homeBannerApi()); // Refresh the table
          } catch (error) {
            console.error(
              "Update failed:",
              error.response?.data || error.message,
            );
            toast.error(error.response?.data?.message || error.message);
          }
        };

        return (
          <button
            className={`px-3 py-1 rounded ${
              isActive ? "bg-green-500" : "bg-red-500"
            } text-white`}
            onClick={handleStatusToggle}
          >
            {isActive ? "Active" : "Inactive"}
          </button>
        );
      },
    }),
    columnHelper.accessor("createdAt", {
      header: "Created At",
      Cell: (cell) => cell.row.original.createdAt.split("T")[0],
    }),

    columnHelper.accessor("updatedAt", {
      header: "Updated At",
      Cell: (cell) => cell.row.original.updatedAt.split("T")[0],
    }),

    columnHelper.accessor("Actions", {
      header: "Actions",
      Cell: ({ cell }) => {
        const rowData = cell?.row?.original;
        return (
          <>
            <Tooltip title="Edit">
              <IconButton onClick={() => handleEdit(rowData)}>
                <EditIcon color="primary" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Delete">
              <IconButton onClick={() => handleDelete(rowData)}>
                <DeleteIcon color="error" />
              </IconButton>
            </Tooltip>
          </>
        );
      },
    }),
  ];

  return (
    <>
      <ToastContainer />
      <Card sx={{ mb: 4 }}>
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12} md={3}>
              <TextField
                label="Title"
                fullWidth
                name="title"
                value={formData.title}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                label="Subtitle"
                fullWidth
                name="subtitle"
                value={formData.subtitle}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                label="Button Text"
                fullWidth
                name="buttonText"
                value={formData.buttonText}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                label="Button Link"
                fullWidth
                name="buttonLink"
                value={formData.buttonLink}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                label="External Link"
                fullWidth
                name="externalLink"
                value={formData.externalLink}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                type="file"
                fullWidth
                name="homebanner_upload"
                // onChange={(e) =>
                //   setFormData((prev) => ({
                //     ...prev,
                //     homebanner_upload: e.target.files[0],
                //   }))
                // }
                onChange={(e) => {
                  const file = e.target.files[0];
                  setSelectedFile(file);
                }}
              />

              {fileError ? (
                <FormHelperText error>{fileError}</FormHelperText>
              ) : (
                <FormHelperText>
                  Allowed file type{" "}
                  {allowedExtensions.map((format) => `.${format}`).join(", ")}{" "}
                  with max size {maxSize / (1024 * 1024)} MB
                </FormHelperText>
              )}
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                label="Title Color"
                type="color"
                fullWidth
                name="titleColor"
                value={formData.titleColor}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                label="Subtitle Color"
                type="color"
                fullWidth
                name="subtitleColor"
                value={formData.subtitleColor}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                label="Button Background"
                type="color"
                fullWidth
                name="buttonBgColor"
                value={formData.buttonBgColor}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                label="Button Text Color"
                type="color"
                fullWidth
                name="buttonTextColor"
                value={formData.buttonTextColor}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <FormControl fullWidth>
                <InputLabel>Portal</InputLabel>
                <Select
                  name="portal"
                  value={formData.portal}
                  label="Portal"
                  onChange={handleChange}
                >
                  <MenuItem value="web">web</MenuItem>
                  <MenuItem value="partner">partner</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={isEditMode ? 1.5 : 3}>
              <Button
                size="large"
                width="fullWidth"
                variant="contained"
                color="primary"
                fullWidth
                onClick={handleSubmit}
                disabled={loading}
                sx={{
                  p: { xs: 1, sm: 1.8, md: 1.8 },
                  width: {
                    xs: "100%",
                    sm: "100%",
                    md: "100%",
                    lg: "100%",
                    xl: "100%",
                  },
                  transition: "transform 0.5s ease-in-out",
                  "&:hover": {
                    transform: "scale(1.01)", // Increase size on hover
                    // boxShadow: "1px 2px 3px 4px yellow", // Add shadow on hover
                  },
                }}
              >
                {loading ? (
                  <CircularProgress size={20} sx={{ color: "#fff" }} />
                ) : isEditMode ? (
                  "Upload"
                ) : (
                  "Submit"
                )}
              </Button>
            </Grid>
            {isEditMode && (
              <Grid item xs={12} md={1.5}>
                <Button
                  variant="contained"
                  // color="secondary"
                  fullWidth
                  onClick={resetForm}
                  sx={{
                    backgroundColor: "#bc2020 !important", // red color
                    // color:"white",
                    p: { xs: 1, sm: 1.8, md: 1.8 },
                    width: {
                      xs: "100%",
                      sm: "100%",
                      md: "100%",
                      lg: "100%",
                      xl: "100%",
                    },
                    transition: "transform 0.5s ease-in-out",
                    "&:hover": {
                      transform: "scale(1.01)", // Increase size on hover
                      // boxShadow: "1px 2px 3px 4px yellow", // Add shadow on hover
                      backgroundColor: "#ca2727", // Darker green on hover
                    },
                  }}
                >
                  Cancel
                </Button>
              </Grid>
            )}
          </Grid>
        </CardContent>
      </Card>
      <CustomTable
        columns={columns}
        data={sliceResponse}
        loading={stateLoading}
        permissionKey="HomeBanner"
      />

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Full Subtitle Text :</DialogTitle>
        <DialogContent>
          <Box
            sx={{
              height: "300px",
              overflowY: "scroll",
              overflowX: "hidden",
              pr: 1,

              // Show scrollbar on right side (for WebKit browsers like Chrome)
              "&::-webkit-scrollbar": {
                width: "8px",
              },
              "&::-webkit-scrollbar-track": {
                backgroundColor: "#f1f1f1",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#888",
                borderRadius: "4px",
              },
              "&::-webkit-scrollbar-thumb:hover": {
                backgroundColor: "#555",
              },

              // For Firefox support
              scrollbarWidth: "thin",
              scrollbarColor: "#888 #f1f1f1",
            }}
          >
            <Typography whiteSpace="pre-line">{fullSubtitle}</Typography>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
}
